'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeTransformSafe = maybeTransformSafe;
exports.transformExistentialExpression = transformExistentialExpression;
exports.transformSafeSpreadElement = transformSafeSpreadElement;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _variables = require('../helpers/variables');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Optional-replacement algorithm based on babel-plugin-transform-optional-chaining
// See https://github.com/babel/babel/blob/master/packages/babel-plugin-transform-optional-chaining/src/index.js

function findReplacementPath(path) {
  return path.find(function (path) {
    var key = path.key,
        parentPath = path.parentPath;

    if (key === "left" && (0, _types.isa)(parentPath, "AssignmentExpression")) return false;else if (key === "object" && (0, _types.isa)(parentPath, "MemberExpression")) return false;else if (key === "callee" && ((0, _types.isa)(parentPath, "CallExpression") || (0, _types.isa)(parentPath, "NewExpression"))) return false;else if (key === 0 && path.listKey === "arguments" && path.parent.tilde) return false; // lift past tilde calls
    else if (key === "argument" && (0, _types.isa)(parentPath, "UpdateExpression")) return false;else if (key === "argument" && (0, _types.isa)(parentPath, "UnaryExpression") && parentPath.node.operator === "delete") return false;else return true;
  });
}function replaceOptionals(path, replacementPath) {
  var scope = path.scope;

  var optionals = [];
  var nil = scope.buildUndefinedNode();

  // Collect all optional nodes within the local cluster of nodes
  var objectPath = path;
  while ((0, _types.isa)(objectPath, "MemberExpression") || (0, _types.isa)(objectPath, "CallExpression") || (0, _types.isa)(objectPath, "NewExpression")) {
    var _objectPath = objectPath,
        node = _objectPath.node;

    if (node.optional) optionals.push(node);

    if ((0, _types.isa)(objectPath, "MemberExpression")) {
      objectPath = objectPath.get("object");
    } else {
      objectPath = objectPath.get("callee");
    }
  } // Traverse optionals from innermost to outermost
  for (var i = optionals.length - 1; i >= 0; i--) {
    var _node = optionals[i];
    _node.optional = false;

    var isCall = (0, _types.isa)(_node, "CallExpression");
    var replaceKey = isCall || (0, _types.isa)(_node, "NewExpression") ? "callee" : "object";
    var chain = _node[replaceKey];

    // Memoize the expression we're chaining from.
    // XXX: non-idiomatic usage of let/now here is due to https://github.com/lightscript/lightscript/issues/47
    // XXX: This was fixed sometime in 2.0 branch but self hosting compiler has not caught up yet.
    // XXX: remember to cleanup when we bring self-hosting forward
    var check = void 0;
    if (isCall && (0, _types.isa)(chain, "MemberExpression")) {
      var _hoistRef = (0, _variables.hoistRef)(path, chain.object, "obj"),
          objectRef = _hoistRef.ref,
          objectAssign = _hoistRef.assign;

      var _ref = chain.computed ? (0, _variables.hoistRef)(path, chain.property, "prop") : { ref: chain.property, assign: chain.property },
          propertyRef = _ref.ref,
          propertyAssign = _ref.assign;

      chain.object = objectRef;
      chain.property = propertyRef;
      check = _types2.default.memberExpression(objectAssign, propertyAssign, chain.computed);
    } // NOTE: The babel transform sometimes generates `Function#call` here which may be more
    // semantically correct.
    else {
        var ref = !(0, _variables.isSimple)(chain) ? scope.maybeGenerateMemoised(chain) : void 0;
        check = ref ? (_node[replaceKey] = ref, _types2.default.assignmentExpression("=", ref, chain)) : chain;
      }replacementPath.replaceWith(_types2.default.conditionalExpression(isCall ? _types2.default.binaryExpression("!==", _types2.default.unaryExpression("typeof", check), _types2.default.stringLiteral("function")) : _types2.default.binaryExpression("==", check, _types2.default.nullLiteral()), nil, replacementPath.node));

    replacementPath = replacementPath.get("alternate");
  }
}function maybeTransformSafe(path) {
  if (path.node.optional) {
    replaceOptionals(path, findReplacementPath(path));
  }
}function transformExistentialExpression(path) {
  return path.replaceWith((0, _astLocUtils.placeAtNode)(_types2.default.binaryExpression("!=", path.node.argument, (0, _astLocUtils.placeAtNode)(_types2.default.nullLiteral(), path.node)), path.node));
}function transformSafeSpreadElement(path) {
  var argument = path.node.argument;
  // Optimization: if the thing being spread is already an array, elide

  if ((0, _types.isa)(argument, "ArrayExpression")) {
    path.node._safe = true;
    return;
  } // Optimization: if spreading an `IfExpr` without an alternate, just add
  // `[]` as an alternate if consequent is an array
  if ((0, _types.isa)(argument, "IfExpression") && (0, _types.isa)(argument.consequent, "ArrayExpression") && !argument.alternate) {
    argument.alternate = _types2.default.arrayExpression();
    path.get("argument").replaceWith(argument);
    path.node._safe = true;
    return;
  }
  var _hoistRef2 = (0, _variables.hoistRef)(path, path.node.argument, "ref"),
      ref = _hoistRef2.ref,
      assign = _hoistRef2.assign,
      isComplex = _hoistRef2.isComplex;

  var cond = _types2.default.conditionalExpression(_types2.default.binaryExpression("===", ref, _types2.default.unaryExpression("void", _types2.default.numericLiteral(0))), _types2.default.arrayExpression(), ref);

  var nextNode = (0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.spreadElement(isComplex ? _types2.default.sequenceExpression([assign, cond]) : cond), (0, _astLocUtils.getLoc)(path.node));

  nextNode._safe = true;
  return path.replaceWith(nextNode);
}